// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 22H3V20H21V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.1553 10.2227H10.8447L12 7.71973L13.1553 10.2227Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 18H1V2H23V18ZM11.0527 5L6.67285 14.4893L8.48926 15.3271L9.92188 12.2227H14.0781L15.5107 15.3271L17.3271 14.4893L12.9473 5H11.0527Z"}}]};

const AutomationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'automation-filled',
    ref,
    icon: element,
  },
));

AutomationFilledIcon.displayName = 'AutomationFilledIcon';

export default AutomationFilledIcon;
